import { render, staticRenderFns } from "./BaseConhecimentoDash.vue?vue&type=template&id=3ab308e7&"
import script from "./BaseConhecimentoDash.vue?vue&type=script&lang=js&"
export * from "./BaseConhecimentoDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports